import { formatLocalStorageKey } from '../nav/utils';

export function makeSearchHistoryUtils(
  maxSize: number,
  localStorageKey: string,
) {
  function getSearchHistory() {
    const value = window.localStorage.getItem(localStorageKey);
    if (!value) {
      return [];
    }

    try {
      const history = JSON.parse(value);
      if (
        Array.isArray(history) &&
        history.every((item) => typeof item === 'string')
      ) {
        return history;
      }
      return [];
    } catch {}

    return [];
  }

  function appendSearchHistory(keyword: string) {
    if (!keyword || !keyword.trim().length) {
      return;
    }
    keyword = keyword.trim();
    let history = getSearchHistory();
    if (history.includes(keyword)) {
      history = history.filter((item) => item !== keyword);
    }
    const newHistory = [keyword].concat(history).slice(0, maxSize);
    window.localStorage.setItem(localStorageKey, JSON.stringify(newHistory));
  }

  return {
    getSearchHistory: getSearchHistory,
    appendSearchHistory: appendSearchHistory,
  };
}

const SIZE = 5;
const LOCALSTORAGE_KEY = formatLocalStorageKey('ZGlobalSearchHistory');

export const { getSearchHistory, appendSearchHistory } = makeSearchHistoryUtils(
  SIZE,
  LOCALSTORAGE_KEY,
);
